module.exports = __webpack_public_path__ + "img/department.0688d924.svg";